import React from 'react';

import './Loading.component.css';

export default class Loading extends React.Component {
    
    render() {
        return (
            <div className="loading-container">
                Loading...
                <br />
                <br />

                <div className="lds-dual-ring"></div>
            </div>
        );
    }
}